import React from 'react';
import { CollapseBlock } from '../../../../../common';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const AttendanceEventDetailTable = ({ event }) => {
  const { t } = useTranslation();
  const date = dayjs(event.started_at).format('DD.MM.YYYY');
  const startTime = dayjs(event.started_at).format('HH:mm');
  const endTime = dayjs(event.ended_at).format('HH:mm');
  const dayInWeek = dayjs(event.started_at).day();

  const daysInWeek = {
    1: 'Pondelok',
    2: 'Utorok',
    3: 'Streda',
    4: 'Štvrtok',
    5: 'Piatok',
  };

  return (
    <CollapseBlock collapsible title={t('Základné informácie o udalosti')}>
      <table className="table table-striped table-bordered">
        <tbody>
          {(() => {
            if (event.title != null) {
              return (
                <tr>
                  <td style={{ width: '200px' }}>
                    <b>{t('Názov')}</b>
                  </td>
                  <td>{event.title}</td>
                </tr>
              );
            } else if (event.subject_id != null) {
              return (
                <tr>
                  <td style={{ width: '200px' }}>
                    <b>{t('Predmet')}</b>
                  </td>
                  <td>
                    {event.subject_id.code} - {event.subject_id.name}
                  </td>
                </tr>
              );
            }
          })()}
          <tr>
            <td>
              <b>{t('Miestnosť')}</b>
            </td>
            <td>{event.room}</td>
          </tr>
          <tr>
            <td>
              <b>{event.title == null ? t('Vyučujúci') : t('Organizátor')}</b>
            </td>
            <td>{event.created_by.full_name}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Zastupujúci')}</b>
            </td>
            <td>
              {event.teacher_id == null
                ? t('Žiadny')
                : event.teacher_id.full_name}
            </td>
          </tr>
          <tr>
            <td>
              <b>{t('Dátum')}</b>
            </td>
            <td>
              {date} ({daysInWeek[dayInWeek]})
            </td>
          </tr>
          <tr>
            <td>
              <b>{t('Čas')}</b>
            </td>
            <td>
              {startTime} - {endTime}
            </td>
          </tr>
        </tbody>
      </table>
    </CollapseBlock>
  );
};

AttendanceEventDetailTable.propTypes = {
  event: PropTypes.object,
};

export default AttendanceEventDetailTable;
